import React, { useEffect, useState } from "react";
import StepSatu from "../FormUMK/StepSatu";
import StepDua from "../FormUMK/StepDua";
import StepTiga from "../FormUMK/StepTiga";
import useAxios from "../../../../Utils/useAxios";
import {
  getDateToday,
  getUser,
  generateDateStringWithNumber,
  addSevenDays,
  formatRP,
} from "../../../../Utils/externalFunctions";
import { convertRPInputToIntValue } from "../../../../Utils/otherFunctions";
import { FORM_TYPE } from "../../../../Constant/FormType";
import FormStepContainer from "../../../../Layout/Containers/FormStepContainer";
import generateUniqueId from "../utils/generateUniqueId";
import { getAnggaranBUK, getRencImpNotZero, getUnitKerja } from "../services";

const CreateUMK = () => {
  const axiosInstance = useAxios();

  const [data, setData] = useState({
    rencImp: [],
    unitKerja: [],
    anggaranBUK: [],
    anggaranRencimpUMK: [],
  });

  const [formUMK, setFormUMK] = useState({
    id_umk: generateUniqueId(),
    id_unit_kerja: "",
    vendor: "",
    nilai: "",
    keterangan: "",
    diajukan_oleh: getUser(),
    kode_umk: generateDateStringWithNumber(),
    tanggal_diajukan: getDateToday("original"),
    batas_akhir: "",
    disetujui_oleh: "",
    dibayar_oleh: "",
    dibayarkan_ke: "",
    tanggal_mulai: "",
    tanggal_selesai: "",
  });

  const [total, setTotal] = useState(0);
  const [formattedNilai, setFormattedNilai] = useState("0");
  const [anggaranRencimpFormattedNilai, setAnggaranRencimpFormattedNilai] =
    useState([]);

  const [step, setStep] = useState(0);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: rencImpData } = await getRencImpNotZero(axiosInstance);
      setData((prev) => ({ ...prev, rencImp: rencImpData }));

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setData((prev) => ({ ...prev, unitKerja: unitKerjaData }));
      setFormUMK((prev) => ({
        ...prev,
        id_unit_kerja:
          unitKerjaData.length === 1 ? unitKerjaData[0].nama_unit_kerja : "",
      }));

      const { data: anggaranBUKData } = await getAnggaranBUK(axiosInstance);
      setData((prev) => ({ ...prev, anggaranBUK: anggaranBUKData }));
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [data.anggaranRencimpUMK]);

  useEffect(() => {
    setAnggaranRencimpFormattedNilai(() => {
      return data.rencImp.map((item) => {
        return {
          pk: item.pk,
          formatted_nilai: "0",
          isValid: true,
        };
      });
    });
  }, [data.rencImp]);

  const calculateTotal = () => {
    let sum = 0;
    data.anggaranRencimpUMK.forEach((item) => {
      const value = parseFloat(item.anggaran_digunakan);
      if (!isNaN(value)) {
        sum += value;
      }
    });
    setTotal(sum);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nilai") {
      const numericValue = convertRPInputToIntValue(value);
      setFormUMK((prev) => ({
        ...prev,
        nilai: numericValue,
      }));
      setFormattedNilai(formatRP(numericValue));
    } else if (name === "tanggal_selesai") {
      const addedTanggal = addSevenDays(value, 14);
      setFormUMK((prev) => ({
        ...prev,
        tanggal_selesai: value,
        batas_akhir: addedTanggal,
      }));
    } else {
      setFormUMK((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const fieldType = e.target.getAttribute("data-field-type");

    const numericValue = convertRPInputToIntValue(value);

    setAnggaranRencimpFormattedNilai((prev) => {
      return prev.map((item) => {
        if (item.pk === parseInt(id)) {
          return { ...item, formatted_nilai: formatRP(numericValue) };
        } else {
          return item;
        }
      });
    });

    if (numericValue === 0) {
      setData((prev) => ({
        ...prev,
        anggaranRencimpUMK: prev.anggaranRencimpUMK.filter(
          (item) => item.rencana_imp !== id
        ),
      }));
    } else {
      setData((prev) => {
        const existingObject = prev.anggaranRencimpUMK.find(
          (item) => item.rencana_imp === id
        );
        console.log("existingObject", existingObject);
        let returnObject;
        if (existingObject) {
          returnObject = prev.anggaranRencimpUMK.map((item) =>
            item.rencana_imp === id
              ? { ...item, [fieldType]: numericValue }
              : item
          );
        } else {
          returnObject = {
            id_anggaran_dipakai_umk: formUMK.id_umk,
            rencana_imp: id,
            [fieldType]: numericValue,
          };
        }
        return {
          ...prev,
          anggaranRencimpUMK: existingObject
            ? returnObject
            : [...prev.anggaranRencimpUMK, returnObject],
        };
      });
    }
  };

  const handleFileChange = (e) => {
    const doc = e.target.files[0];
    setFormUMK((prev) => ({
      ...prev,
      doc: doc,
    }));
  };

  const nextStep = (e) => {
    setStep(step + 1);
  };

  const prevStep = (e) => {
    setStep(step - 1);
  };

  return (
    <FormStepContainer step={step}>
      <StepSatu
        nextStep={nextStep}
        handleChange={handleChange}
        formUMK={formUMK}
        unitKerja={data.unitKerja}
        formattedNilai={formattedNilai}
      />
      <StepDua
        nextStep={nextStep}
        prevStep={prevStep}
        handleInputChange={handleInputChange}
        total={total}
        rencImp={data.rencImp}
        anggaranRencimpUMK={data.anggaranRencimpUMK}
        formUMK={formUMK}
        unitKerja={data.unitKerja}
        anggaranRencimpFormattedNilai={anggaranRencimpFormattedNilai}
        setAnggaranRencimpFormattedNilai={setAnggaranRencimpFormattedNilai}
        formType={FORM_TYPE.Create}
      />
      <StepTiga
        prevStep={prevStep}
        total={total}
        formUMK={formUMK}
        rencImp={data.rencImp}
        anggaranRencimpUMK={data.anggaranRencimpUMK}
        formType={FORM_TYPE.Create}
      />
    </FormStepContainer>
  );
};

export default CreateUMK;
